import React from 'react';
import { Tag, MessageCircleQuestion } from 'lucide-react';
import { repairPriceBandText, getRepairMinPrice } from '../constants/repairPricing';

/**
 * RepairPriceBand (Sprint 1.1 / FELADAT 3)
 *
 * Informatív ársáv a korábbi semmitmondó „Egyedi ajánlat” helyett:
 *   • ismert minimum ár  → „Kijelzőcsere már 20 000 Ft-tól”
 *   • nincs ismert ár    → „Kérj személyre szabott ajánlatot”
 *
 * Hamis árat SOHA nem jelenít meg – az adat a constants/repairPricing.js-ből jön.
 * A `note` a sáv alatti magyarázó sor (pl. miért nincs fix ár).
 */
export default function RepairPriceBand({ service, brand, note, className = '', testId }) {
  const text = repairPriceBandText(service, brand);
  const known = getRepairMinPrice(service, brand) !== null;
  const Icon = known ? Tag : MessageCircleQuestion;

  return (
    <div
      data-testid={testId || `repair-price-band-${service}-${brand}`}
      className={`inline-flex flex-col gap-1 ${className}`}
    >
      <span
        className={`inline-flex items-center gap-2 px-4 py-2 rounded-full font-semibold text-sm ${
          known ? 'bg-brand/10 text-brand-hover' : 'bg-gray-100 text-gray-700'
        }`}
      >
        <Icon size={16} aria-hidden="true" />
        {text}
      </span>
      {note && <span className="text-xs text-gray-500">{note}</span>}
    </div>
  );
}
